import { numberFormatPrice } from '@/common/app/utils/numberUtils';
import URL from '@/common/app/utils/urlsUtils';
import { Gradient } from '@/screens/CommonPage/ui/commonPage/CardItem/cardItem/CardImage/CardImage.styles';
import * as S from './NewFeaturedActivitiesPreview.styles';
import { useInView } from 'react-intersection-observer';
import { IRecommendsItem } from './FeaturedActivitiesPreview.types';
import { IReview } from '@/entities/Activity/domain/Review.domain';
import Link from 'next/link';
import {
    convertRecommendedDataToAnalyticsData,
    createListNameFromPath,
    wraitDetasilsData,
} from '@/shared/Analytics/GA4/helpers';
import { promotionInterceptor } from '@/shared/Analytics/GA4/promotionInterceptor';
import { trackSelectPromotion } from '@/shared/Analytics/GA4';
import { myImageLoader } from '@/lib/imageLoader';
import { defaultPlaceholder } from '@/shared/images/preloader/defaultPlaceholder';
import { ReviewsBlock } from '@/entities/Reviews/ui/ReviewBlock';
import { setNewTabListName } from '@/shared/ListNameData';
import { useRouter } from 'next/router';

export const NewFeaturedActivitiesPreview = (
    props:
        | IRecommendsItem & {
              position: number;
              listName: string;
              reviews_cnt?: string;
              rate_count?: string;
              reviews?: IReview[];
              item_list_name: string;
              item_list_id: string;
              promotion_name?: string;
              isDesktop: boolean;
              isWebApp: boolean;
              isWidget?: boolean;
              isBlur?: boolean;
          }
) => {
    const {
        duration,
        price,
        url,
        id,
        rating_stars,
        name,
        price_strike_out,
        reviews_cnt,
        rate_count,
        position,
        reviews,
        item_list_name,
        item_list_id,
        promotion_name,
        placeholder,
        rating,
        isDesktop,
        isWebApp,
        isWidget,
        isBlur,
    } = props;
    const { asPath } = useRouter();

    const priceWithComma = numberFormatPrice(price);
    const priceStrikeOutWithComma =
        price_strike_out && price_strike_out > price ? numberFormatPrice(price_strike_out) : '';

    const [ref] = useInView({
        threshold: 1,
        delay: 100,
        trackVisibility: true,
        triggerOnce: true,
        onChange: (inView) => {
            if (inView && !isWidget) {
                promotionInterceptor.addPromotion(
                    convertRecommendedDataToAnalyticsData({
                        id,
                        name,
                        analytics_data: (props as IRecommendsItem).analytics_data,
                        google: props.google,
                        price,
                        price_strike_out,
                        position,
                        item_list_name,
                        item_list_id,
                        isFeatured: true,
                    }),
                    promotion_name
                );
            }
        },
    });

    const clickHandler = () => {
        const listNameData = {
            index: position + 1,
            item_list_name,
            item_list_id,
            promotion_name: promotion_name || '',
            item_category3: createListNameFromPath(),
        };

        wraitDetasilsData(listNameData);

        if (isDesktop) {
            setNewTabListName(url.toLowerCase(), listNameData);
        }

        trackSelectPromotion({
            creative_name: createListNameFromPath(),
            promotion_name: promotion_name || '',
            items: [
                {
                    ...convertRecommendedDataToAnalyticsData({
                        id,
                        name,
                        analytics_data: props.analytics_data,
                        google: props.google,
                        price,
                        price_strike_out,
                        position,
                        item_list_name,
                        item_list_id,
                        isFeatured: true,
                    }),
                },
            ],
        });
    };

    const href =
        isWidget && asPath.includes('?')
            ? url.toLowerCase() + '?' + asPath.split('?')[1]
            : url.toLowerCase();

    return (
        <Link href={href} passHref prefetch={false}>
            <S.CardWidth
                ref={ref}
                className="card"
                onClick={clickHandler}
                target={isWidget || (isDesktop && !isWebApp) ? '_blank' : '_self'}
            >
                <S.PreviewWrapper>
                    <S.ImageContainer isBlur={isBlur}>
                        <S.ImgWrap>
                            <Gradient />
                            <S.ImageComponent
                                loader={myImageLoader}
                                src={`${URL.image}/activity/${id}/center/480x320/ts`}
                                width={240}
                                height={160}
                                alt={name}
                                blurDataURL={placeholder || defaultPlaceholder}
                                placeholder="blur"
                                priority={!position}
                            />
                        </S.ImgWrap>
                        <S.PriceWrapper>
                            <>
                                {!!priceStrikeOutWithComma && (
                                    <S.StrikeOut>{priceStrikeOutWithComma}</S.StrikeOut>
                                )}
                                &nbsp;
                                <S.Price>{priceWithComma}</S.Price>
                            </>
                        </S.PriceWrapper>
                    </S.ImageContainer>
                    <S.ContentContainer isBlur={isBlur}>
                        <S.Title>{name}</S.Title>
                        <S.DurationWrapper>
                            <ReviewsBlock
                                rating={rating}
                                reviews={reviews}
                                reviewsCnt={reviews_cnt}
                                rateCount={rate_count}
                                ratingStars={rating_stars}
                                emptyReviewsMsg="Newly added"
                            />
                            <S.Time>
                                {duration !== '' && (
                                    <>
                                        <S.ClockIcon />
                                        <S.Minutes>{duration}</S.Minutes>
                                    </>
                                )}
                            </S.Time>
                        </S.DurationWrapper>
                    </S.ContentContainer>
                </S.PreviewWrapper>
            </S.CardWidth>
        </Link>
    );
};
